var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionPlanLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m197.23 476.52-54.777-50.922 23.801-25.551 30.801 28.523 56.523-53.723 24.152 25.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.5 122.5h262.5v35h-262.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.5 227.5h262.5v35h-262.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.5 332.5h122.5v35h-122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m525.18 542.5h-140.18v-35h140.18c28.875 0 52.324-23.449 52.324-52.324v-350.35c0-28.875-23.449-52.324-52.324-52.324h-262.85c-28.875 0-52.324 23.449-52.324 52.324v157.68h-35v-157.68c0-48.125 39.199-87.324 87.324-87.324h262.68c48.125 0 87.324 39.199 87.324 87.324v350.35c0 48.125-39.199 87.324-87.324 87.324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280 542.5h-140c-28.875 0-52.5-23.625-52.5-52.5v-140c0-28.875 23.625-52.5 52.5-52.5h140c28.875 0 52.5 23.625 52.5 52.5v140c0 28.875-23.625 52.5-52.5 52.5zm-140-210c-9.625 0-17.5 7.875-17.5 17.5v140c0 9.625 7.875 17.5 17.5 17.5h140c9.625 0 17.5-7.875 17.5-17.5v-140c0-9.625-7.875-17.5-17.5-17.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPlanLogo);
export default __webpack_public_path__ + "static/media/action-plan-logo.07c87174ae0d570ac64777116fee042b.svg";
export { ForwardRef as ReactComponent };